import { URL_PATH } from 'utils/constants';
import { useCallback } from 'react';

export const useNavigateOrigin = () => {
  const originRoute = URL_PATH;
  const navigateOrigin = useCallback(() => {
    window.location.replace(originRoute);
  }, [originRoute]);

  return {
    navigateOrigin,
    originRoute,
  };
};
